import { FunctionComponent, useContext } from 'react'

import { AppDrawer, Flex, Masthead, Page, StudySidebarCard } from '@medable/medable-web-ui'
import { AuthContext } from '@medable/medable-web-framework'
import { AuthContextType } from '@medable/medable-web-framework/dist/contexts/AuthContext'

import { useStudyCard } from '@/hooks/use-study-card'
import { MastheadWrapperStyled, StudySidebarCardWrapperStyled } from './layout.styles'

export const Layout: FunctionComponent = ({ children }) => {
  const { logout, user } = useContext<AuthContextType>(AuthContext)
  const studyCard = useStudyCard()

  const firstName = user.name?.first ? user.name.first : ''
  const lastName = user.name?.last ? user.name.last : ''
  const name = `${firstName} ${lastName}`.trim()

  const UtilityProps = {
    profile: {
      name: name?.toUpperCase(),
      menuItems: [{ text: 'Sign Out', actionCallback: logout }],
    },
  }

  return (
    <Page>
      <MastheadWrapperStyled>
        <Masthead UtilityProps={UtilityProps} />
      </MastheadWrapperStyled>

      <Flex className='flex-grow overflow-hidden'>
        <AppDrawer>
          <Flex col>
            {studyCard && (
              <StudySidebarCardWrapperStyled>
                <StudySidebarCard className='align-left' {...studyCard} />
              </StudySidebarCardWrapperStyled>
            )}
          </Flex>
        </AppDrawer>

        <Flex className='w-full bg-white'>{children}</Flex>
      </Flex>
    </Page>
  )
}
